import { Box, Typography } from "@mui/material";
import React from "react";
import { useIntl } from "react-intl";

export default function Legend() {

  const intl = useIntl();

  const axes = [
    { label: intl.formatMessage({ id: "EditModel.xAxis" }), color: "red" },
    { label: intl.formatMessage({ id: "EditModel.yAxis" }), color: "green" },
    { label: intl.formatMessage({ id: "EditModel.zAxis" }), color: "blue" },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: 1,
        backgroundColor: "#f5f5f5", // Light background
        boxShadow: 1,
        border: '1px solid',
        borderRadius: 3
      }}
    >
      {axes.map((axis) => (
        <Box
          key={axis.label}
          sx={{
            display: "flex",
            alignItems: "center"
          }}
        >
          {/* Small line */}
          <Box
            sx={{
              width: "20px",
              height: "2px",
              backgroundColor: axis.color,
              marginRight: 1,
            }}
          />
          {/* Axis label */}
          <Typography variant="body1" sx={{ color: "text.primary" }}>
            {axis.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}